/**
 * МИКСИНЫ — переиспользуемые фрагменты inline-стилей.
 * Возвращают обычные style-объекты, которые можно разворачивать через spread:
 *   <div style={{ ...mixins.card, padding: space[4] }} />
 */

import { color, radius, shadow, font } from "./tokens";

export const flexCenter = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const flexBetween = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const truncate = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const card = {
  background: color.surface,
  border: `1px solid ${color.border}`,
  borderRadius: radius.lg,
  boxShadow: shadow.md,
};

export const srOnly = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0,0,0,0)",
  whiteSpace: "nowrap",
  border: 0,
};

/** Заголовок секции/страницы. */
export const pageTitle = {
  fontSize: font.size["2xl"],
  fontWeight: font.weight.medium,
  color: color.ink,
  margin: 0,
};

/** Утилита для склейки классов (мелкий clsx). */
export function cx(...parts) {
  return parts.filter(Boolean).join(" ");
}

const mixins = { flexCenter, flexBetween, truncate, card, srOnly, pageTitle, cx };
export default mixins;
